import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type TransferRefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/transferRefundForRefundOfRefundsDetailViewModel";
import Section from "views/common/section";
import { Col, Form, Row } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatDate } from "utils/localizations";

const TransferRefundForRefundOfRefundOriginalPaymentView: ViewComponent<TransferRefundForRefundOfRefundsDetailViewModel> =
  observer(({ vm }) => {
    return (
      <Section title={vm.translate("originalRefundPayment.title")} context={vm.item} className="mt-6">
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("refundForRefundOfRefund", "originalRefundPostingDate")}</Form.Label>
            <FakeInput
              target={vm.item}
              property="originalRefundPostingDate"
              valueFormatter={(date?: Date) => (date ? formatDate(new Date(date)) : undefined)}
            />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("transferSourcePaymentDetail", "postingDate")}</Form.Label>
            <FakeInput
              target={vm.item.originalPayment}
              property="postingDate"
              valueFormatter={(date?: Date) => (date ? formatDate(new Date(date)) : undefined)}
            />
          </Form.Group>
        </Row>
      </Section>
    );
  });

export default TransferRefundForRefundOfRefundOriginalPaymentView;
